import { render, staticRenderFns } from "./SystemRequirements.vue?vue&type=template&id=297f332c&scoped=true&"
import script from "./SystemRequirements.vue?vue&type=script&lang=js&"
export * from "./SystemRequirements.vue?vue&type=script&lang=js&"
import style0 from "./SystemRequirements.vue?vue&type=style&index=0&id=297f332c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f332c",
  null
  
)

export default component.exports